import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';

export const ACC_RUN_STATUSES = {
	NOT_STARTED: 'notStarted',
	IN_PROGRESS: 'inProgress',
	READY_FOR_APPROVAL: 'readyForApproval',
	APPROVED: 'approved',
	CHANGES_APPLIED: 'changesApplied',
};

export const ACC_AUDIT_MATCH_STATUSES = {
	MATCHED: 'matched',
	MatchedWithVariance: 'matchedWithVariance',
	NeedsVerification: 'needsVerification',
	Missing: 'missing',
	NewAsset: 'newAsset',
};

export const ACC_AUDIT_CHANGE_APPLY_STATUSES = {
	RunInProgress: 'runInProgress',
	Logged: 'logged',
	ReLog: 'reLog',
	WaitingForApproval: 'waitingForApproval',
	Approved: 'approved',
	Failed: 'failed',
	ChangesApplied: 'changesApplied',
};

export const ACC_AUDIT_KEY_DISPLAY_NAMES = {
	[ACC_AUDIT_MATCH_STATUSES.MATCHED]: 'Matched',
	[ACC_AUDIT_MATCH_STATUSES.MatchedWithVariance]: 'Matched with variance',
	[ACC_AUDIT_MATCH_STATUSES.NeedsVerification]: 'Matched but needs verification',
	[ACC_AUDIT_MATCH_STATUSES.Missing]: 'Missing',
	[ACC_AUDIT_MATCH_STATUSES.NewAsset]: 'New Asset',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.RunInProgress]: 'Draft',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.Logged]: 'Logged',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.ReLog]: 'Re-log Asset',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.WaitingForApproval]: 'Pending Approval',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.Approved]: 'Approved',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.Failed]: 'Failed',
	[ACC_AUDIT_CHANGE_APPLY_STATUSES.ChangesApplied]: 'Changes Applied',
};

export const NEEDS_VERIFICATION_VALUE_WITH_LABEL = [
	{
		key: 'assignQRCodeAndRemoveFromMatch',
		label: 'Mark to assign QR & remove from match',
	},
	{
		key: 'swapQRCodes',
		label: 'Mark to swap QR codes (default)',
	},
	{
		key: 'applyNewQRCode',
		label: 'Mark to assign new QR code',
	},
	{
		key: 'qrCodeRemoved',
		label: 'QR code removed',
		hidden: true,
	},
	{
		key: 'needsFurtherReview',
		label: 'Needs further review',
		hidden: true,
	},
];

export const MISSING_ASSET_VALUE_WITH_LABEL = [
	{
		key: 'makeInactive',
		label: 'Mark to make asset inactive (default)',
	},
	{
		key: 'transfer',
		label: 'Mark to transfer',
	},
	{
		key: 'delete',
		label: 'Mark to delete asset',
	},
];

export const ACC_AUDIT_ACTIONABLE_STATUSES = [
	ACC_AUDIT_CHANGE_APPLY_STATUSES.Approved,
	ACC_AUDIT_CHANGE_APPLY_STATUSES.ReLog,
	ACC_AUDIT_CHANGE_APPLY_STATUSES.WaitingForApproval,
];

export const getCycleRunCounts = (cycleRun, assetTypeId?: number) => {
	const assetCountBasedOnAssetType = assetTypeId
		? nullSafeGet('assetCountBasedOnAssetType', cycleRun).find((c) => c.assetTypeId === assetTypeId)
		: nullSafeGetOrElse('assetCountBasedOnAssetType', cycleRun, []);
	const totalAssets = (
		Array.isArray(assetCountBasedOnAssetType)
			? assetCountBasedOnAssetType
			: [assetCountBasedOnAssetType]
	).reduce((sum, assetTypeItem) => {
		return (
			sum +
			nullSafeGetOrElse('totalAssetCount', assetTypeItem, 0) +
			nullSafeGetOrElse('newAssetCount', assetTypeItem, 0) +
			nullSafeGetOrElse('transferAssetCount', assetTypeItem, 0)
		);
	}, 0);

	const assetsLogged = (
		Array.isArray(assetCountBasedOnAssetType)
			? assetCountBasedOnAssetType
			: [assetCountBasedOnAssetType]
	).reduce((sum, assetTypeItem) => {
		return sum + (nullSafeGet('capturedAssetCount', assetTypeItem) || 0);
	}, 0);

	const newAssetAdded = (
		Array.isArray(assetCountBasedOnAssetType)
			? assetCountBasedOnAssetType
			: [assetCountBasedOnAssetType]
	).reduce((sum, assetTypeItem) => {
		return sum + (nullSafeGet('newAssetCount', assetTypeItem) || 0);
	}, 0);
	const transferCount = (
		Array.isArray(assetCountBasedOnAssetType)
			? assetCountBasedOnAssetType
			: [assetCountBasedOnAssetType]
	).reduce((sum, assetTypeItem) => {
		return sum + (nullSafeGet('transferAssetCount', assetTypeItem) || 0);
	}, 0);

	return {
		totalAssets,
		assetsLogged,
		newAssetAdded,
		transferCount,
	};
};
